import { brand, productName, uiBuildVersion } from '@/services/branding'

function getTitle (vm) {
  if (vm.$route && vm.$route.meta) {
    const { title } = vm.$route.meta
    if (title) {
      return typeof title === 'function'
        ? title(vm)
        : title
    }
  }
}

export default {
  created () {
    const title = getTitle(this)
    const version = uiBuildVersion()
    if (title) {
      document.title = `${title} • ${brand} ${version}`
    } else {
      document.title = `${productName} ${version}`
    }
  }
}